import React from "react";
import { CrossIcon } from "@aureskonnect/react-ui";

import { resetAllPeripherals } from "@pages/Applications/DeviceAssociateModal/store";
import {
    setActions,
    setIsActionsClicked,
} from "@pages/Peripherals/Monetics/store";
import { CustomCardHeader } from "@components/Common/CustomCardStyled";

import { useMoneticsForm } from "../MoneticsFormContext";

/** Card header: form title + close (X) button. */
export function MoneticFormHeader() {
    const { form, props } = useMoneticsForm();
    const { title, isActionsClicked } = form;
    const {
        isEdited,
        isAddMoneticsClicked,
        setIsAddMoneticsClicked,
        setEditedData,
        setIsEdited,
        setIsConsult,
    } = props;

    const closeForm = () => {
        resetAllPeripherals();
        setEditedData([]);
        setIsAddMoneticsClicked(!isAddMoneticsClicked);
        setIsEdited(false);
        setIsConsult(false);
    };

    return (
        <CustomCardHeader
            className="d-flex align-items-center justify-content-between"
            style={{ maxHeight: "76px" }}
        >
            <h5 className="pt-3 mnt_txt_addPaymentDevice">{title}</h5>
            <CrossIcon
                className="icon-close-notification__clz mnt_icn_closeForm"
                data-testid="monetics-close-icon"
                height={13}
                width={13}
                onClick={() => {
                    if (isEdited) {
                        setIsActionsClicked(!isActionsClicked);
                        setActions(closeForm());
                    } else {
                        closeForm();
                    }
                }}
            />
        </CustomCardHeader>
    );
}
